module.exports = __webpack_public_path__ + "img/bni.909ddaf8.svg";